import * as React from 'react';
import './ListItem.scss';
import classNames from 'classnames';
import { IconProps, Icon } from '../Icon';

export type ListItemProps = React.HTMLAttributes<any> & {
    children: React.ReactNode;
    component?: (props: Record<string, unknown>) => React.ReactNode;
};

export const ListItem: React.FunctionComponent<ListItemProps> = ({ children, className, component, ...props }) => (
    <>
        {component ? (
            <li>{component({ ...props, children, className: classNames(className, 'ListItem--flex') })}</li>
        ) : (
            <li {...props} className={classNames(className, 'ListItem--default ListItem--flex')}>
                {children}
            </li>
        )}
    </>
);

export const ListItemIcon: React.FunctionComponent<IconProps> = ({ className, ...props }) => (
    <span className={classNames('ListItem__icon', className)}>
        <Icon {...props} />
    </span>
);

export type ListItemTextProps = React.HTMLAttributes<any> & {
    children?: React.ReactNode;
};

export const ListItemText: React.FunctionComponent<ListItemTextProps> = ({ children, className, ...props }) => (
    <span className={classNames('ListItem__text', className)} {...props}>
        {children}
    </span>
);
